import { Injectable } from '@angular/core';
import { Queue } from '@df/util/queue/queue';

@Injectable({
    providedIn: 'root'
})
export class RequestQueue {
    private readonly queue = new Queue({ max: 5 });

    add<T = any>(cb: () => Promise<T>): Promise<T> {
        return this.queue.add<T>(cb);
    }
}
